import styled from 'styled-components';

export const SearchButton = styled.button`
  height: 40px;
  background-color: rgb(243, 168, 71);
  border-radius: 0px 10px 10px 0px;
  border: 1px solid black;
  opacity: 0.9;

  &:hover {
    opacity: 1;
  }
`
export const Div = styled.div`
  display: flex;
  height: 40px;
  width: 50%;
`

export const Input = styled.input`
  background-color: white;
  border-radius: 10px 0px 0px 10px;
  width: 100%;
  border: 1px solid black;
  padding-left: 30px;
`
